/*
 * Copyright (c) 2023. Collabro Limited
 */

const ModecDark = {};

export default ModecDark;
